import { PhaseString } from "types/global"
import { getPhasesDictionary, PHASE_SLUG } from "./utils"



/**
 * dato un array di LAYERS
 * restituisce un dictionary con i nomi della PHASES come key
 * e un array di layer per ogni KEY
 * mantiene l'ordine definito in "stores/phase/utils.js"
 * @example
 * { "phase1": [{<layer>},{<layer>},...], "phase2": [{<layer>},{<layer>},...], ...}
 */
export function groupLayersByPhases<T extends LayerCommon>(layers: T[], showLayersDisabled?: boolean): { [phase: string]: T[] } {
	if (layers == null) return {}

	// raggruppo i LAYERs per TUTTE le PHASES (anche quelle senza LAYER)
	const groupsLayers = layers.reduce((acc, layer) => {
		let phase = layer.phase ?? PHASE_SLUG.UNKNOW
		if ((layer.disabled && !showLayersDisabled) || phase == PHASE_SLUG.PRE_CYCLE || phase == PHASE_SLUG.POST_CYCLE) return acc
		if (acc[phase] == null) acc[phase] = []
		acc[phase].push(layer)
		return acc
	}, getPhasesDictionary<T>())
	
	// rimuovo le PHASES senza LAYERs e restituisco
	return Object.keys(groupsLayers).reduce((acc, key) => {
		const value = groupsLayers[key]
		if (!value || value.length == 0) return acc
		acc[key] = value.sort((a, b) => a.layerNumber - b.layerNumber)
		return acc
	}, {})
}

interface LayerCommon {
	phase?: PhaseString,
	disabled?: boolean,
	layerNumber?: number,
}

/**
 * Da un DICTIONARY di Layer per PHASE rivavo un array con una specie di map
 * @param phases 
 * @param callback 
 * @returns 
 */
export function ungroupLayerByPhases(phases, callback) {
	return Object.keys(phases).reduce((acc, phase) => {
		const layers = phases[phase]
		if (callback) {
			return acc.concat(layers.map(layer => callback(phase, layer)))
		} else {
			return acc.concat(layers)
		}
	}, [])
}